import * as PropTypes from "prop-types";
import {connect} from 'react-redux';
import {ff, form, Loader, utils} from "@mc/mc-legacy";
import * as React from "react";
import {Component} from "react";
import {Col, FormGroup, Row} from "reactstrap";
import {formValueSelector, reduxForm} from "redux-form";
import * as EnumFormaDoruceni from "../../api/gen/cgo/EnumFormaDoruceni";
import * as adresaFormatter from "../../utils/adresaFormatter";
import RadioField from "../fields/RadioField";
import * as ciselnikActions from "../../actions/ciselnikActions";
import {formatDate, formatTime, getMaximalniCas, getMinimalniCas} from "../../utils/utils";
import moment from "moment";
import {WithTranslation, withTranslation} from "react-i18next";

const {Form, FormActions, FormBody} = form;

/**
 * Formulář pro úpravu způsobu dopravy a platby.
 */
class DopravaPlatbaForm extends Component<WithTranslation> {

    static formName = 'DopravaPlatbaForm';

    static propTypes = {
        adresyList: PropTypes.array, // adresy uživatele + případně společnosti
        zpusobyDopravyList: PropTypes.array.isRequired, // seznam způsobů dopravy
        zpusobyPlatbyList: PropTypes.array.isRequired, // seznam způsobů dopravy
        pobockyList: PropTypes.array.isRequired, // seznam poboček typu výdejní místo
        zobrazovatCasOd: PropTypes.instanceOf(Date), // minimální čas který lze vybrat pro čas vyzvednutí, může být null pokud žádný čas nelze vybrat
        zobrazovatCasDo: PropTypes.instanceOf(Date), // maximální čas který lze vybrat pro čas vyzvednutí, může být null pokud žádný čas nelze vybrat
        krokCasMinut: PropTypes.number.isRequired, // velikost kroku ve výběru času
    };

    static validate = (values, props) => {
        const {t} = props;
        const errors = {};
        if (values.naPobocku) {
            if (!values.pobockaId) {
                errors.pobockaId = t('validation.branch_required');
            }
            if (!values.datumVyzvednuti) {
                errors.datumVyzvednuti = t('validation.pickup_date_required');
            }
            if (values.datumVyzvednuti && moment(values.datumVyzvednuti).startOf('day') < moment().startOf('day')) {
                errors.datumVyzvednuti = t('validation.pickup_date_future');
            }
            if (!values.casVyzvednuti) {
                errors.casVyzvednuti = t('validation.pickup_time_required');
            }
            // TODO berka chybí validate na čas vyzvednutí!
        } else {
            if (!values.datumDoruceni) {
                errors.datumDoruceni = t('validation.delivery_date_required');
            }
            if (values.datumDoruceni && moment(values.datumDoruceni).startOf('day') < moment().startOf('day')) {
                errors.datumDoruceni = t('validation.delivery_date_future');
            }
            // TODO berka tohle nezabere potom co ho změní automat při změně datumu nebo pobočky!
            if (!values.terminDopravaId || values.terminDopravaId === "") {
                errors.terminDopravaId = t('validation.delivery_time_required');
            }
            if (!values.ulice) {
                errors.ulice = t('validation.field_required');
            }
            if (!values.obec) {
                errors.obec = t('validation.field_required');
            }
            if (!values.psc) {
                errors.psc = t('validation.field_required');
            }
        }
        return errors;
    };

    constructor(props) {
        super(props);
        this.state = {
            zobrazovatCasOd: props.zobrazovatCasOd,
            zobrazovatCasDo: props.zobrazovatCasDo,
        }
    }

    componentDidMount() {
        this.fetchData();
    }

    componentDidUpdate(prevProps) {
        this.fetchData();
        // Při přenačtení termínů dopravy vynutíme nastavení prvního - jinak se stává že je nastavený jiný než který je právě zobrazen v comboboxu
        const prevTerminy = prevProps.terminyDopravyList;
        const thisTerminy = this.props.terminyDopravyList;
        if (thisTerminy && (!prevTerminy || prevTerminy && prevTerminy.rows !== thisTerminy.rows) && thisTerminy.rows.length > 0) {
            this.props.change('terminDopravaId', thisTerminy.rows[0].id);
        }
    }

    fetchData = () => {
        const {zpusobDopravaId, datumDoruceni, initialValues} = this.props;
        this.props.dispatch(ciselnikActions.fetchFirmaIfNeeded());
        const selectedDatum = datumDoruceni || initialValues.datumDoruceni;
        if (zpusobDopravaId && selectedDatum) {
            const datum = selectedDatum && formatDate(selectedDatum, null, "YYYY-MM-DD") || null;
            this.props.dispatch(ciselnikActions.fetchTerminyDopravyOperatorIfNeeded(zpusobDopravaId, datum));
        }
    };

    handleZpusobDopravyChange = (zpusobDoprava) => {
        const {zpusobDopravaId, datumDoruceni} = this.props;
        const naPobocku = zpusobDoprava.formaDoruceni === EnumFormaDoruceni.POB;
        this.props.change('naPobocku', naPobocku);
        if (!naPobocku && zpusobDopravaId && datumDoruceni) {
            const datum = datumDoruceni && formatDate(datumDoruceni, null, "YYYY-MM-DD") || null;
            this.props.dispatch(ciselnikActions.fetchTerminyDopravyOperatorIfNeeded(zpusobDopravaId, datum, true));
        }
    };

    handleClearAdresa = () => {
        this.props.change('adresa', null);
    };

    handleAdresaChange = (adresa) => {
        this.props.change('ulice', adresa.ulice);
        this.props.change('psc', adresa.psc);
        this.props.change('obec', adresa.obec);
        this.props.change('stat', adresa.stat);
    };

    handleDatumDoruceniChange = (datumDoruceni) => {
        if (datumDoruceni.target) datumDoruceni = datumDoruceni.target.value;
        const {zpusobDopravaId} = this.props;
        if (zpusobDopravaId) {
            const datum = datumDoruceni && formatDate(datumDoruceni, null, "YYYY-MM-DD") || null;
            this.props.dispatch(ciselnikActions.fetchTerminyDopravyOperatorIfNeeded(zpusobDopravaId, datum, true));
            this.props.change('terminDopravaId', null);
        }
    };

    handleDatumVyzvednutiChange = (event) => {
        const {pobockaVznikId} = this.props;
        this.updateOmezeniCasu(pobockaVznikId && parseInt(pobockaVznikId), event.target.value);
    };

    updateOmezeniCasu = (pobockaId, datumVyzvednuti) => {
        const {pobockyList, firmaDetail} = this.props;
        const pobocka = pobockyList.find(p => p.id === pobockaId);
        const min = getMinimalniCas(firmaDetail.data, pobocka, datumVyzvednuti);
        const max = getMaximalniCas(firmaDetail.data);
        this.setState({zobrazovatCasOd: min, zobrazovatCasDo: max}, () => this.props.change('casVyzvednuti', formatTime(min)));
    };

    handlePobockaChange = (event) => {
        const {pobockaVznikId} = this.props;
        const pobockaId = event && event.target.value && parseInt(event.target.value) || pobockaVznikId && parseInt(pobockaVznikId);
        this.updateOmezeniCasu(pobockaId, this.props.datumVyzvednuti);
    };

    render() {
        const {onClose, handleSubmit, submitting, adresyList, pobockyList, naPobocku, zpusobyDopravyList,
            zpusobyPlatbyList, krokCasMinut, terminyDopravyList, firmaDetail, t} = this.props;
        const {zobrazovatCasOd, zobrazovatCasDo} = this.state;

        if (!firmaDetail.fetched) {
            return <Loader/>;
        }

        return <Form onSubmit={handleSubmit} horizontal>
            <FormBody>
                <Row>
                    <Col xs={8}>
                        <FormGroup>
                            <h2>{t('order.step.delivery')}</h2>
                            {zpusobyDopravyList.map(zpusobDoprava =>
                                <RadioField
                                    key={zpusobDoprava.id}
                                    name="zpusobDopravaId"
                                    label={zpusobDoprava.nazevDoprava}
                                    value={zpusobDoprava.id}
                                    onChange={this.handleZpusobDopravyChange.bind(this, zpusobDoprava)}
                                />
                            )}
                            {naPobocku ? <div>
                                    <Row>
                                        <Col xs={12} md={8}>
                                            <ff.Select label={t('choose_branch')} name="pobockaVznikId" disabled={submitting} onChange={this.handlePobockaChange}>
                                                {pobockyList.map(pobocka =>
                                                    <option key={pobocka.id} value={pobocka.id}>{pobocka.nazevPobocka}</option>
                                                )}
                                            </ff.Select>
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} md={8}>
                                            <ff.SimpleDate min={new Date()} label={t('pickup_date')} name="datumVyzvednuti" onChange={this.handleDatumVyzvednutiChange} />
                                        </Col>
                                    </Row>
                                    <Row>
                                        <Col xs={12} md={8}>
                                            <ff.Time min={zobrazovatCasOd} max={zobrazovatCasDo} step={krokCasMinut} label={t('pickup_time')} name="casVyzvednuti"/>
                                        </Col>
                                    </Row>
                                </div> :
                                <div>
                                    <ff.SimpleDate min={new Date()} label={t('delivery_date')} name="datumDoruceni" onChange={this.handleDatumDoruceniChange} />
                                    <ff.Select label={t('delivery_time')} name="terminDopravaId" disabled={submitting}>
                                        {terminyDopravyList.rows.map(r => <option key={r.id} value={r.id}>{r.nazevTermin}</option>)}
                                    </ff.Select>
                                    <Row className={"mt-3"}>
                                        <Col xs={12}>
                                            <ff.ObjectSuggest
                                                label={t('choose_address')}
                                                name="adresa"
                                                dropdown={true}
                                                removable={false}
                                                getItemValue={(item) => item ? adresaFormatter.getUplnaAdresa(item) : ""}
                                                renderSuggestion={item => item ? adresaFormatter.getUplnaAdresa(item) : ""}
                                                items={adresyList}
                                                onChange={this.handleAdresaChange}
                                            />
                                            <ff.String label={t('street')} name="ulice" disabled={submitting} onChange={this.handleClearAdresa} />
                                            <ff.Number label={t('zip')} name="psc" disabled={submitting} onChange={this.handleClearAdresa} />
                                            <ff.String label={t('city')} name="obec" disabled={submitting} onChange={this.handleClearAdresa} />
                                            <ff.String label={t('country')} name="stat" disabled={submitting} onChange={this.handleClearAdresa} />
                                        </Col>
                                    </Row>
                                </div>}
                        </FormGroup>
                    </Col>
                    <Col xs={4}>
                        <FormGroup>
                            <h2>{t('order.step.payment')}</h2>
                            {zpusobyPlatbyList.map(zpusobPlatba =>
                                <RadioField
                                    key={zpusobPlatba.id}
                                    name="zpusobPlatbaId"
                                    label={zpusobPlatba.nazevZpusobPlatba}
                                    value={zpusobPlatba.id}
                                />
                            )}
                        </FormGroup>
                    </Col>
                </Row>
            </FormBody>
            <FormActions onClose={onClose} cancelButton={t('buttons.cancel')} storeButton={t('save')} disabled={submitting}/>
        </Form>
    }
}

const selector = formValueSelector(DopravaPlatbaForm.formName);

const mapStateToProps = state => ({
    naPobocku: selector(state, 'naPobocku'),
    zpusobDopravaId: selector(state, 'zpusobDopravaId'),
    datumDoruceni: selector(state, 'datumDoruceni'),
    datumVyzvednuti: selector(state, 'datumVyzvednuti'),
    pobockaVznikId: selector(state, 'pobockaVznikId'),
    terminyDopravyList: utils.storeFromArea(state, ciselnikActions.TERMINY_DOPRAVY_OPERATOR_LIST_AREA),
    firmaDetail: utils.storeFromArea(state, ciselnikActions.FIRMA_AREA),
});

export default withTranslation()(connect(mapStateToProps)(reduxForm({
    form: DopravaPlatbaForm.formName,
    validate: DopravaPlatbaForm.validate,
})(DopravaPlatbaForm)));
